var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tableBox',{attrs:{"url":'/Flat/SelUserfflineTrainings',"exportUrl":'/Flat/ExportSelUserfflineTrainings',"ifState":true,"ifSearch":true,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }